export default import.meta.ROLLDOWN_FILE_URL_XcFh7yLKgKT$LYDcTgyccQ